<template>
  <div>
    <label
        for="container"
    >
      {{label}}
    </label><br><br>
    <div name="container">
      <input
        v-model="date.day"
        :messageError="messageErrorDay"
        :class="$v.date.day.$error ? `a-input-primary a-input-danger ` : `a-input-primary `"
        type="text"
        placeholder="dd"
        size="1"
        maxlength="2"
        name="day"
        @blur="$v.date.day.$touch()"
      />
      <label
        for="day"
      >
        /
      </label>
      <select
        v-model="date.month"
        id="months"
        :class="$v.date.month.$error ? `a-input-primary a-input-danger` : `a-input-primary`"
        @blur="$v.date.month.$touch()"
      >
      <option
        disabled
        selected
        value=""
      >
      </option>
      <option
        v-for="(month,index) in months"
        :key="month[index]"
        :value="months[index]"
        :selected="months[index] === value ? true : false"
      >
        {{months[index]}}
      </option>
      </select>
      <label
        for="year"
      >
        /
      </label>
      <input
        v-model.number="date.year"
        :messageError="messageErrorYear"
        :class="$v.date.year.$error ? `a-input-primary a-input-danger` : `a-input-primary`"
        size="2"
        type="text"
        placeholder="yyyy"
        maxlength="4"
        name="year"
        @blur="$v.date.year.$touch(), validate()"
      >
    </div>
      <small
        v-if="$v.date.day.$error"
        class="text-color-danger"
      >
        {{messageErrorDay}}
      </small>
        <br>
      <small
        v-if="$v.date.month.$error"
        class="text-color-danger"
      >
        {{messageErrorMonth}}
      </small>
        <br>
      <small
        v-if="$v.date.year.$error"
        class="text-color-danger"
      >
        {{messageErrorYear}}
      </small>
  </div>
</template>

<script>
import { minLength, required, between, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'AtomInputDatePrimary',

  props: {
    label: String
  },

  data () {
    return {
      date: {
        day: '',
        month: '',
        year: ''
      },

      months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Oct', 'Nov', 'Dic'],
      messageError: '',
      value: ''
    }
  },

  validations: {
    date: {
      day: {
        minLength: minLength(2),
        numeric,
        between: between(1, 31),
        required
      },

      month: {
        required
      },

      year: {
        minLength: minLength(4),
        numeric,
        required
      }
    }
  },

  computed: {
    messageErrorDay () {
      return this.$validation.getValidationMessage('aInputDatePrimary', this.$v.date.day, 'day')
    },

    messageErrorYear () {
      return this.$validation.getValidationMessage('aInputDatePrimary', this.$v.date.year, 'year')
    },

    messageErrorMonth () {
      return this.$validation.getValidationMessage('aInputDatePrimary', this.$v.date.month, 'month')
    }
  },

  methods: {
    validate () {
      switch (this.date.month) {
        case 'Feb':
          if (this.date.day === '29' && !((this.date.year % 4 === 0) && ((this.date.year % 100 !== 0) || (this.date.year % 400 === 0)))) {
            return this.$alerts.pushAlert('aInputDatePrimary', 'updateDate', 'error', 'a-alert-danger')
          } else if (this.date.day > 29) {
            return this.$alerts.pushAlert('aInputDatePrimary', 'updateDate', 'error', 'a-alert-danger')
          }
          break

        case 'Abr':
        case 'Jun':
        case 'Sep':
        case 'Nov':
          if (this.date.day > 30) {
            return this.$alerts.pushAlert('aInputDatePrimary', 'updateDate', 'error', 'a-alert-danger')
          }
          break
      }
      if (!(this.$v.date.day.$error && this.$v.date.month.$error && this.$v.date.year.$error)) {
        this.updateValue()
      }
    },

    updateValue () {
      this.$emit('date', this.date)
    }
  }
}
</script>
